import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './cloud.css';
import App from './App';
import CloudApp from './cloud/CloudApp';
import CloudErrorBoundary from './cloud/CloudErrorBoundary';
import EditorErrorBoundary from './EditorErrorBoundary';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
const cloudEnabled = window.__VR_TOUR_CLOUD__?.enabled === true;
root.render(
  <React.StrictMode>
    {cloudEnabled ? (
      <CloudErrorBoundary>
        <CloudApp />
      </CloudErrorBoundary>
    ) : (
      <EditorErrorBoundary>
        <App />
      </EditorErrorBoundary>
    )}
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
